import React, { useRef } from "react";
import { Star, Quote } from "lucide-react";
import { useInView } from "../hooks/useInView";
import { testimonials } from "../data/mock";

export const TestimonialsSection = () => {
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, { threshold: 0.1 });

  return (
    <section
      id="testimonials"
      ref={sectionRef}
      className="section-padding relative"
      style={{ backgroundColor: "#F5F0E8" }}
    >
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div
          className={`text-center max-w-2xl mx-auto mb-16 ${
            isInView ? "animate-fade-in-up" : "opacity-0"
          }`}
        >
          <span className="text-gold text-sm font-semibold tracking-widest uppercase mb-4 block">
            Testimonials
          </span>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-charcoal mb-6">
            What Our Clients{" "}
            <span className="text-gold-gradient">Say</span>
          </h2>
          <p className="text-charcoal/60 text-lg leading-relaxed">
            Don't just take our word for it. Hear from couples and event
            organizers who trusted us with their most important celebrations.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className={`testimonial-card p-8 rounded-2xl bg-white border border-border relative ${
                isInView ? "animate-fade-in-up" : "opacity-0"
              }`}
              style={{
                animationDelay: `${(index + 1) * 150}ms`,
                animationFillMode: "both",
              }}
            >
              {/* Quote Icon */}
              <Quote className="h-10 w-10 text-gold/20 mb-4" />

              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {Array.from({ length: testimonial.rating }).map((_, i) => (
                  <Star key={i} className="h-4 w-4 fill-gold text-gold" />
                ))}
              </div>

              {/* Content */}
              <p className="text-charcoal/70 leading-relaxed text-sm mb-6">
                "{testimonial.content}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-3 pt-4 border-t border-border">
                <div className="w-10 h-10 rounded-full bg-gold/10 flex items-center justify-center">
                  <span className="text-gold font-semibold text-sm">
                    {testimonial.name
                      .split(" ")
                      .map((n) => n[0])
                      .join("")
                      .slice(0, 2)}
                  </span>
                </div>
                <div>
                  <div className="font-semibold text-charcoal text-sm">
                    {testimonial.name}
                  </div>
                  <div className="text-xs text-charcoal/50">
                    {testimonial.role} · {testimonial.event}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
